import I18N from '@leverege/i18n';
import TableModelInitializer from "../../attributes/TableModelInitializer.js";
import DataViewerModelUpdaterCreator from "../DataViewerModelUpdaterCreator.js";
import TableContentView from "./TableContentView.js";
const {
  tf,
  tfIcon
} = I18N.ns('molten.dataViewers.table.TableDataViewer');
export default {
  id: 'molten.dataViewers.table.TableDataViewer',
  type: 'molten.Table',
  name: tf('name'),
  icon: tfIcon('tableIcon', 'fa fa-table fa-fw'),
  location: 'none',
  matches: {
    type: 'GroupDataViewer'
  },
  component: TableContentView,
  settingsUpdaters: DataViewerModelUpdaterCreator.create('TableViewModelUpdater'),
  createSettings: props => {
    return TableModelInitializer.create(props.objectType, true, props);
  },
  reset: async props => {},
  getDefaultCardContentOptions: {
    height: '400px'
  }
};